import { render, staticRenderFns } from "./ScripticItemPhotos.vue?vue&type=template&id=38afb5eb"
import script from "./ScripticItemPhotos.vue?vue&type=script&lang=ts"
export * from "./ScripticItemPhotos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports